// extracted by mini-css-extract-plugin
module.exports = {"container":"Loader_container__3_EeY","dot":"Loader_dot__D0KBM","reveal":"Loader_reveal__tIGGk","slide":"Loader_slide__1Xq0W"};